import { Sidebar } from './Sidebar'
const theseusLogo = '/theseus-logo.png'

type DashboardLayoutProps = {
  children: React.ReactNode
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Logo top left */}
      <a
        href="https://theseus.us"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed top-4 left-4 md:top-6 md:left-6 flex items-center gap-2 hover:opacity-80 transition-opacity z-30"
      >
        <img src={theseusLogo} alt="Theseus" className="h-5 md:h-6" />
      </a>

      {/* Centered container with sidebar + content */}
      <div className="min-h-screen flex justify-center">
        <div className="flex w-full max-w-5xl pt-14 md:pt-20 px-4 md:px-0">
          <Sidebar />
          <main className="flex-1 md:px-8 py-6">
            {children}
          </main>
        </div>
      </div>
    </div>
  )
}
